export default class InformationRequestScore {
  id?: number;
  score: number;
  citizen_request_id: number;
  entity_id?: number;

  constructor(values: InformationRequestScoreConstructValues) {
    this.id = values.id;
    this.score = values.score;
    this.citizen_request_id = values.citizen_request_id;
    this.entity_id = values.entity_id;
  }
}

export interface InformationRequestScoreConstructValues {
  id?: number;
  score: number;
  citizen_request_id: number;
  entity_id?: number;
}
